import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Loader from "../Loader/Loader";
import InvoiceDateField from "../../pages/ExpenseManagement/InvoiceDateField";
import { todayYmd } from "../../pages/ExpenseManagement/expenseStyles";

/* "Generate Invoice" popup: asks for the invoice date before the invoice is made.
   Defaults to today; past and future dates are allowed, but it can't be empty
   (same rule as the Branch Jobs invoice date).

   Props
     show, onHide
     count            how many bookings are going on the invoice (optional, for the text)
     onConfirm(invoiceDate)  -> Promise   'YYYY-MM-DD'; does the generating. The popup
                                          stays open (button busy) until it finishes,
                                          then closes itself.
*/
function InvoiceDateDialog({ show, onHide, count = 0, onConfirm }) {
  const [invoiceDate, setInvoiceDate] = useState(todayYmd);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (show) setInvoiceDate(todayYmd());
  }, [show]);

  const submit = async () => {
    if (!invoiceDate || busy) return;
    setBusy(true);
    try {
      await onConfirm(invoiceDate);
    } finally {
      setBusy(false);
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={() => !busy && onHide()} centered backdrop="static">
      <Modal.Header closeButton={!busy}>
        <Modal.Title style={{ fontSize: "18px" }}>Generate Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ fontSize: "14px", color: "#374151" }}>
          Choose the date to show on the invoice
          {count ? ` (${count} booking${count === 1 ? "" : "s"} selected)` : ""}. It is today unless you change it.
        </p>
        {/* Only mount the picker while open so it isn't built on every page load. */}
        {show && <InvoiceDateField value={invoiceDate} onChange={setInvoiceDate} />}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-outline-secondary px-4" onClick={onHide} disabled={busy}>
          Cancel
        </button>
        <button
          className="btn btn-danger px-4"
          onClick={submit}
          disabled={!invoiceDate || busy}
          title={invoiceDate ? "" : "Choose the invoice date"}
        >
          {busy ? <Loader style={{ width: 40, height: 20 }} /> : "Generate Invoice"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default InvoiceDateDialog;
